/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import { Fade } from 'react-awesome-reveal';

// Brand-colored SVG logos served from public icon CDNs
const simpleIcon = (slug) => `https://cdn.simpleicons.org/${slug}`;
const techStack = [
  { name: 'TensorFlow', logo: simpleIcon('tensorflow') },
  { name: 'PyTorch', logo: simpleIcon('pytorch') },
  { name: 'Claude AI', logo: simpleIcon('claude') },
  { name: 'Google Gemini', logo: simpleIcon('googlegemini') },
  { name: 'AWS SageMaker', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg' },
  { name: 'Google Cloud', logo: simpleIcon('googlecloud') },
  { name: 'Firebase', logo: simpleIcon('firebase') },
  { name: 'Flutter', logo: simpleIcon('flutter') },
  { name: 'React', logo: simpleIcon('react') },
  { name: 'Node.js', logo: simpleIcon('nodedotjs') },
  { name: 'Kotlin', logo: simpleIcon('kotlin') },
  { name: 'Swift', logo: simpleIcon('swift') },
];

export default function Partners() {
  return (
    <section className="py-16 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-12">
            <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-2">
              Trusted Technology Stack
            </p>
            <h2 className="text-2xl text-gray-600 font-light">
              Built with industry-leading technologies
            </h2>
          </div>
        </Fade>

        <Fade direction="up" delay={200} triggerOnce>
          <div className="flex justify-center mb-10">
            <a
              href="https://www.google.com/partners/agency?id=3338221788"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-gray-300 hover:shadow-md"
              aria-label="View Drava Studio Google Partner profile"
            >
              <img
                src="https://www.gstatic.com/partners/badge/images/2026/PartnerBadgeClickable.svg"
                alt="Google Partner"
                className="h-24 w-auto"
              />
            </a>
          </div>
        </Fade>

        <Fade direction="up" delay={300} triggerOnce>
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 max-w-4xl mx-auto">
            {techStack.map((tech) => (
              <div
                key={tech.name}
                className="flex flex-col items-center justify-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-gray-300 hover:shadow-md"
              >
                <img
                  src={tech.logo}
                  alt={`${tech.name} logo`}
                  loading="lazy"
                  className="h-8 w-8 object-contain"
                />
                <span className="text-xs text-gray-500">{tech.name}</span>
              </div>
            ))}
          </div>
        </Fade>
      </div>
    </section>
  );
}
